import { useQuery } from "@tanstack/react-query"
import { whatsappIntegrationQuery } from "../../lib/whatsapp/whatsappIntegrationQuery"

export function useWhatsappIntegrationConfigurationQuery(
  ...args: Parameters<typeof whatsappIntegrationQuery>
) {
  return useQuery(whatsappIntegrationQuery(...args))
}
